/** @format */

import { useLanguageContext } from "../context/LanguageContext";
import { flagIcons } from "../assets/icons";
import { LANGUAGES } from "../constants";
import { cloneElement, useState } from "react";

const LanguageSelector = () => {
  const { language, updateLanguage } = useLanguageContext();
  const [isOpen, setOpen] = useState(false);

  function toggleOpen() {
    setOpen((prev) => !prev);
  }
  const handleLanguageChange = (lang) => {
    updateLanguage(lang);
    toggleOpen();
  };

  const flagIcon = flagIcons[language]
    ? cloneElement(flagIcons[language], {
        width: 24,
        height: 24,
        className: "w-6 h-6",
      })
    : null;
  const getFlagIcon = (lang) =>
    flagIcons[lang]
      ? cloneElement(flagIcons[lang], {
          width: 20,
          height: 20,
          className: "w-5 h-5",
        })
      : null;

  return (
    <div
      id="language"
      value={language}
      onChange={handleLanguageChange}
      className="fixed right-10 bottom-20 z-30"
    >
      <button onClick={toggleOpen} className="p-3 rounded-md bg-white">
        {flagIcon}
      </button>
      <div
        className={`
        absolute flex flex-col gap-2 p-2
        -translate-x-[150px]
        bg-white rounded-lg shadow-md
        transition-all duration-500 ease-in-out
        overflow-hidden
        ${
          isOpen
            ? " max-h-[380px] -translate-y-[360px] opacity-100"
            : " max-h-0 -translate-y-[20px] opacity-0"
        }
      `}
      >
        {Object.entries(LANGUAGES).map((el) => (
          <button
            className="flex items-center gap-2 bg-white rounded-lg px-4 py-2 text-sm text-black hover:bg-gray-300 transition duration-300"
            onClick={() => handleLanguageChange(el[1])}
            key={"lng" + el[1]}
          >
            {getFlagIcon(el[1])}
            {el[0]}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSelector;
